import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik, FormikProvider, FieldArray } from "formik";
import { Apitoken, Authtoken } from "../Global";
import FindModuleById from '.././FindModuleById';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const EditInvoicingHeaders = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [showweight, setShowweight] = useState(true);
  const [permission, setPermission] = useState({});
  //const [showDescription, setShowDescription] = useState(false);
  const [customerNames, setcustomerNames] = useState([]);

  const [calibreLabel, setCalibreLabel] = useState('Calibre');

  const invoiceTypesList = [
    { value: '1', label: "Invoice" },
    { value: '4', label: "Produce Invoice" },
    { value: '2', label: "Credit Note" },
    { value: '3', label: "Proforma" },
  ];

  const [invtype, setInvtype] = useState(false);
  const [invtypeid, setInvtypeid] = useState('');
  let { id } = useParams();
  const [value, setValue] = useState({});

  const [calibrehide, setCalibrehide] = useState(false);



  useEffect(() => {
    setPermission(FindModuleById(181));
    console.log(permission);
    axios
      .get(`/invoices/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          //toast.error(response.data.data.invoice_header);
        
        
          var cust =0;
           if (response.data.data.invoice_header.invoice_type == 1) {
      console.log(response.data.data.invoice_header);
           cust = response.data.data.invoice_header.customer_id;
          var typecus = response.data.data.invoice_header.customer_type;
          response.data.data.invoice_header.customer = cust+'-'+typecus;


              setInvtype(true);
            } else {
                console.log(response.data.data.invoice_header);
           cust = response.data.data.invoice_header.customer_id;
          response.data.data.invoice_header.customer = cust;
              setInvtype(false);
            }
          
          setValue(response.data.data.invoice_header);
          setInvtypeid(response.data.data.invoice_header.invoice_type);


          // handleGetAddressByCustomerId(response.data.data.invoice_header.customer_id);

          if (response.data.data.invoice_header.invoice_type == 1 || response.data.data.invoice_header.invoice_type == 2) {
             setShowweight(false);
            setCalibrehide(true)
          } else {
             setShowweight(true);
            setCalibrehide(false)
          }

           

          if (response.data.data.invoice_header.invoice_type == 1) {
            axios.post("/helpers/get-all-customers-supplychain-suppliers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
              .then((response) => {
                // let customers = response.data.data.customers;
                if (response.data.code === 200) {
                  let shipping_methods = response.data.data.customers;
                  let customerOptions = shipping_methods.map((customer, index) => ({
                    label: customer.company_name,
                    value: customer.id,
                    if: customer.if,
                    ice: customer.ice,
                    key: `customer-${index}`,
                  }));
                  setcustomerNames(customerOptions);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            axios.post("/helpers/get-all-customers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
              .then((response) => {
                // let customers = response.data.data.customers;
                if (response.data.code === 200) {
                  let shipping_methods = response.data.data.customers;
                  let customerOptions = shipping_methods.map((customer, index) => ({
                    label: customer.company_name,
                    value: customer.id,
                    key: `customer-${index}`,
                  }));
                  setcustomerNames(customerOptions);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }

          if (response.data.data.invoice_header.invoice_type == 2) {
            axios.get(`/orders-by-customer/listing/${response.data.data.invoice_header.customer_id}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
              .then((response) => {
                if (response.data.code === 200) {
                  let orders = response.data.data.orders;
                  let orderslisting = orders.map((customer, index) => ({
                    label: customer.po_number,
                    value: customer.id,
                    key: `address-${index}`,
                  }));
                  setOrdersLists(orderslisting);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }


        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);





  const formik = useFormik({
    initialValues: {
      id: value.id,
      customer: value.customer,
      order: value.order,
      date: value.date,
      invoicing_address: value.invoicing_address,
      shipping_address: value.shipping_address,
      invoice_type: value.invoice_type,
      country: value.country,
      tax: value.tax,
      packaging_type: value.packaging_type,
      remarks: value.remarks,
      total_amount: value.total_amount,
      total_gross_weight: value.total_gross_weight,
      total_number_of_boxes: value.total_number_of_boxes,
      lot_number: value.lot_number,
      container_number: value.container_number,
      seal_number: value.seal_number,
      contents: value.items,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/invoices/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          //  actions.setSubmitting(false);
          $("#form-submit").text("Update Invoice");
          setSubmitting(false);
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/invoices";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });



  useEffect(() => {
    setPermission(FindModuleById(181));
    console.log(permission);
    setOrdersLists([]);

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            label: customer.productname,
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .get(`/helpers/countries`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let countries = response.data.data.countries;
          let countrieslisting = countries.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `country-${index}`,
          }));
          setCountriesList(countrieslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


  }, []);

useEffect(() => {
  if (!value.customer_id) return; // guard against undefined on first render
  handleGetAddressByCustomerId({ value: value.customer_id });
}, [value.customer_id]);



  const handleGetAddressByCustomerId = (event) => {
    setAddressList([]);
    const customerid = String(event.value);
    const parts = customerid.split("-");
    const customer_id = parts[0];              // always exists
    const customer_type = parts[1] ?? null;    // invoice or null
    if (customer_type === null) {
      axios.post(`/addresses/customer-address-by-customer/${customer_id}`, {}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {

          let customers = response.data.data.addresses;
          console.log(customers);
          let addresses = customers.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `address-${index}`,
          }));

          setAddressList(addresses);
        }
      }).catch((error) => {
        console.log(error);
      });
      axios.get(`/orders-by-customer/listing/${customer_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          if (response.data.code === 200) {
            let orders = response.data.data.orders;
            let orderslisting = orders.map((customer, index) => ({
              label: customer.po_number,
              value: customer.id,
              key: `address-${index}`,
            }));
            setOrdersLists(orderslisting);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (customer_type == 'invoice') {
        axios.post(`/addresses/customer-address-by-customer/${customer_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {

            let customers = response.data.data.addresses;
            console.log(customers);
            let addresses = customers.map((customer, index) => ({
              label: customer.name,
              value: customer.id,
              key: `address-${index}`,
            }));

            setAddressList(addresses);
          }
        }).catch((error) => {
          console.log(error);
        });
        axios.get(`/orders-by-customer/listing/${customer_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            if (response.data.code === 200) {
              let orders = response.data.data.orders;
              let orderslisting = orders.map((customer, index) => ({
                label: customer.po_number,
                value: customer.id,
                key: `address-${index}`,
              }));
              setOrdersLists(orderslisting);
            } else {
              console.log("API response is not an array");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log(event);

        formik.setFieldValue('if', event.if); formik.setFieldValue('ice', event.ice);

        axios.post(`/addresses/customer-address-by-supply-supplier/${customer_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {

            let customers = response.data.data.addresses;
            console.log(customers);
            let addresses = customers.map((customer, index) => ({
              label: customer.address,
              value: customer.address,
              key: `address-${index}`,
            }));

            setAddressList(addresses);
          }
        }).catch((error) => {
          console.log(error);
        });
      }

    }


  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const changeInvoiceType = (event) => {
    const type = event.value;
    setInvtypeid(type);
    if (type == 1) {
      setInvtype(true);
    } else {
      setInvtype(false);
    }

    if (type == 1) {
      axios.post("/helpers/get-all-customers-supplychain-suppliers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          // let customers = response.data.data.customers;
          if (response.data.code === 200) {
            let shipping_methods = response.data.data.customers;
            let customerOptions = shipping_methods.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
              if: customer.if,
              ice: customer.ice,
              key: `customer-${index}`,
            }));
            setcustomerNames(customerOptions);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios.post("/helpers/get-all-customers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          // let customers = response.data.data.customers;
          if (response.data.code === 200) {
            let shipping_methods = response.data.data.customers;
            let customerOptions = shipping_methods.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
              key: `customer-${index}`,
            }));
            setcustomerNames(customerOptions);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (type == 1 || type == 2) {
      setShowweight(false);
      setCalibreLabel('Description'); // Change label to Description

    } else {
      setShowweight(true);
      setCalibreLabel('Calibre'); // Change label back to Calibre
    }
    if (type == 1 || type == 2) {
      setCalibrehide(true)
    } else {
      setCalibrehide(false)
    }
  }


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Invoice</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">Invoice</Link>
                    </li>
                    <li className="breadcrumb-item active">Update Invoice</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Invoice Header</h4>
                    {permission && permission.add === 1 && (
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Invoice Type</label>
                                {invoiceTypesList.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={invoiceTypesList.find(option => option.value == formik.values.invoice_type) || null} // Ensure correct format
                                    name="invoice_type"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("invoice_type", selectedOption);
                                      changeInvoiceType(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={invoiceTypesList}
                                    placeholder="Select"
                                  />

                                )}
                                <small>
                                  {backendErrors.invoice_type && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.invoice_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            {customerNames.length > 0 && (
                              <div className="col-md-6">
                                <div className="form-group status">
                                  <label>Customer</label>
                                  {customerNames.length > 0 && (
                                    <Select
                                      className="w-100"
                                      value={customerNames.find(option => option.value == formik.values.customer) || null} // Ensure correct format
                                      name="customer"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("customer", selectedOption);
                                        handleGetAddressByCustomerId(selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={customerNames}
                                      placeholder="Select"
                                    />
                                  )}

                                  <small>
                                    {backendErrors.customer && (
                                      <span className="form-error mt-1">
                                        {backendErrors.customer}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}
                            {invtypeid && invtypeid == 2 && (
                              <div className="col-md-6">
                                <div className="form-group order status">
                                  <label>Order PO Number</label>
                                  {ordersLists.length > 0 && (
                                    <Select
                                      className="w-100"
                                      value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                                      name="order"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("order", selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={ordersLists}
                                      placeholder="Select"
                                    />

                                  )}

                                  <small>
                                    {backendErrors.order && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.order}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}


                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Invoicing Address</label>
                                {addressList.length > 0 && (<Select
                                  className="w-100"
                                  value={addressList.find(option => option.value == formik.values.invoicing_address) || null} // Ensure correct format
                                  name="invoicing_address"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("invoicing_address", selectedOption);
                                    //handleGetAddressByCustomer(selectedOption);
                                    //getCurrncyByOrder(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={addressList}
                                  placeholder="Select"


                                />)}

                                <small>
                                  {backendErrors.invoicing_address && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.invoicing_address}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shipping Address</label>
                                {addressList.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={addressList.find(option => option.value == formik.values.shipping_address) || null} // Ensure correct format
                                    name="shipping_address"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("shipping_address", selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={addressList}
                                    placeholder="Select"
                                  />

                                )}
                                <small>
                                  {backendErrors.shipping_address && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.shipping_address}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            {invtypeid && invtypeid == 1 && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>TAX %</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="tax"
                                    value={formik.values.tax}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.tax && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.tax}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>


                            )}

                            {invtypeid && invtypeid == 1 && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Discount</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="discount"
                                    value={formik.values.discount}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.discount && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.discount}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>


                            )}


                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="date"
                                  value={formik.values.date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            {invtypeid && invtypeid != 1 && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Country of Origin</label>
                                  {countriesList.length > 0 && (
                                    <Select
                                      className="w-100"
                                      value={countriesList.find(option => option.value == formik.values.country) || null} // Ensure correct format
                                      name="country"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("country", selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={countriesList}
                                      placeholder="Select"
                                    />

                                  )}
                                  <small>
                                    {backendErrors.country && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.country}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}
                            {showweight && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Total Gross Weight</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="total_gross_weight"
                                    value={formik.values.total_gross_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.total_gross_weight && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.total_gross_weight}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}
                            {showweight && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Total Number Of Boxes</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="total_number_of_boxes"
                                    value={formik.values.total_number_of_boxes}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.total_number_of_boxes && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.total_number_of_boxes}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}


                            {invtype && invtypeid == 1 && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>ICE</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="ice"
                                    value={formik.values.ice}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.ice && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.ice}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}


                            {invtype && invtypeid == 1 && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>IF</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="if"
                                    value={formik.values.if}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.if && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.if}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}




                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Remarks</label>
                                <input
                                  type="text"
                                  className="form-input form-control"
                                  name="remarks"
                                  value={formik.values.remarks}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.remarks && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.remarks}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>



                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Invoice Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {
                                    let appendArr = arrayHelpers.form.values.contents[0];
                                    let initialArr = {
                                      product: "",
                                      calibre: "",
                                      quantity: "",
                                      price: "",
                                      // total_number_of_boxes: "",
                                    }
                                    appendArr = (appendArr) ? appendArr : initialArr;
                                    arrayHelpers.push(appendArr);
                                    setShowTableHeadings(true);


                                  }}
                                >
                                  +
                                </button>
                                <table className="table">
                                  {showTableHeadings && (
                                    <thead>
                                      <tr>
                                        {invtype === false && (<th>Product</th>)}
                                        {calibrehide === true && (<th>{calibreLabel}</th>)}
                                        <th>Quanitity</th>
                                        <th>Price</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                  )}
                                  <tbody>
                                    {formik.values.contents && formik.values.contents.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          {invtype === false && (
                                            <td>
                                              <div className="form-group status">
                                                {productLists.length > 0 && (
                                                  <Select
                                                    name={`contents[${index}].product`}
                                                    options={productLists}
                                                    value={productLists.find(option => option.value == formik.values.contents[index].product) || null} // Ensure correct format
                                                    onChange={(selectedOption) => {
                                                      formik.setFieldValue(`contents[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                      customHandleInput({
                                                        target: {
                                                          name: `contents[${index}].product`,
                                                          value: selectedOption.value, // ✅ Ensure only value is passed
                                                        },
                                                      });
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Select"
                                                    className="w-100"
                                                  />

                                                )}
                                              </div>
                                            </td>
                                          )}

                                          {calibrehide === true && (
                                            <td>
                                              <div className="form-group status">
                                                <input
                                                  type="text"
                                                  placeholder={`Enter ${calibreLabel}`}
                                                  className="form-input form-control"
                                                  name={`contents[${index}].calibre`}
                                                  value={
                                                    formik.values.contents[index]
                                                      .calibre
                                                  }
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                          )}

                                          <td>
                                            <div className="form-group status">
                                              <input
                                                type="text"
                                                onKeyPress={(event) => {
                                                  // Allow only numbers (0-9)
                                                  if (!/^[0-9]$/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                placeholder="Enter Quantity"
                                                className="form-input form-control"
                                                name={`contents[${index}].quantity`}
                                                value={
                                                  formik.values.contents[index]
                                                    .quantity
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group status">

                                              <div className="input-group">
                                                <input
                                                  type="text"
                                                  onKeyPress={(event) => {
                                                    // Allow only numbers (0-9)
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  placeholder="Enter Price"
                                                  className="form-input form-control"
                                                  name={`contents[${index}].price`}
                                                  value={
                                                    formik.values.contents[index]
                                                      .price
                                                  }
                                                  onChange={formik.handleChange}
                                                />

                                              </div>


                                            </div>
                                          </td>

                                          <td>
                                            <div className="form-group">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />

                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Update Invoice
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};
export default EditInvoicingHeaders;
